// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EvolutionHistoryPanel_panel__9P\\+jB {
  padding: 18px 20px 20px;
}

.EvolutionHistoryPanel_header__oTwN9 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 12px;
}

.EvolutionHistoryPanel_header__oTwN9 h3 {
  margin: 0;
  color: #263746;
  font-size: 1rem;
}

.EvolutionHistoryPanel_header__oTwN9 p {
  margin: 5px 0 0;
  color: #73828d;
  font-size: .78rem;
}

.EvolutionHistoryPanel_modeSwitch__Ghxa9 {
  display: inline-flex;
  gap: 8px;
  flex: 0 0 auto;
}

.EvolutionHistoryPanel_modeSwitch__Ghxa9 button {
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 7px 11px;
  background: #f1f5f8;
  color: #587084;
  font: inherit;
  font-size: .78rem;
  cursor: pointer;
}

.EvolutionHistoryPanel_modeSwitch__Ghxa9 button:hover,
.EvolutionHistoryPanel_modeSwitch__Ghxa9 button:focus-visible {
  border-color: #b9cad7;
  outline: none;
}

.EvolutionHistoryPanel_modeSwitch__Ghxa9 .EvolutionHistoryPanel_activeMode__5n2fI {
  border-color: #155a70;
  background: #ffffff;
  color: #155a70;
  font-weight: 700;
}

.EvolutionHistoryPanel_state__ofiat,
.EvolutionHistoryPanel_error__oMqHR {
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #71808b;
}

.EvolutionHistoryPanel_error__oMqHR {
  color: #b42318;
}

@media (max-width: 760px) {
  .EvolutionHistoryPanel_panel__9P\\+jB {
    padding: 14px;
  }

  .EvolutionHistoryPanel_header__oTwN9 {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/EvolutionHistoryPanel.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".panel {\n  padding: 18px 20px 20px;\n}\n\n.header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n  margin-bottom: 12px;\n}\n\n.header h3 {\n  margin: 0;\n  color: #263746;\n  font-size: 1rem;\n}\n\n.header p {\n  margin: 5px 0 0;\n  color: #73828d;\n  font-size: .78rem;\n}\n\n.modeSwitch {\n  display: inline-flex;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.modeSwitch button {\n  border: 1px solid transparent;\n  border-radius: 6px;\n  padding: 7px 11px;\n  background: #f1f5f8;\n  color: #587084;\n  font: inherit;\n  font-size: .78rem;\n  cursor: pointer;\n}\n\n.modeSwitch button:hover,\n.modeSwitch button:focus-visible {\n  border-color: #b9cad7;\n  outline: none;\n}\n\n.modeSwitch .activeMode {\n  border-color: #155a70;\n  background: #ffffff;\n  color: #155a70;\n  font-weight: 700;\n}\n\n.state,\n.error {\n  min-height: 260px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: #71808b;\n}\n\n.error {\n  color: #b42318;\n}\n\n@media (max-width: 760px) {\n  .panel {\n    padding: 14px;\n  }\n\n  .header {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `EvolutionHistoryPanel_panel__9P+jB`,
	"header": `EvolutionHistoryPanel_header__oTwN9`,
	"modeSwitch": `EvolutionHistoryPanel_modeSwitch__Ghxa9`,
	"activeMode": `EvolutionHistoryPanel_activeMode__5n2fI`,
	"state": `EvolutionHistoryPanel_state__ofiat`,
	"error": `EvolutionHistoryPanel_error__oMqHR`
};
export default ___CSS_LOADER_EXPORT___;
